// ======================================================================
// File Name       : adaptive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getAdaptiveMetaImportList(params) {
  return commonCallApi({
    path: 'adaptive/EditAdaptiveEngineDataResult',
    data: params,
  });
}

export function importAdaptiveMeta(params) {
  return commonCallApi({
    path: 'adaptive/EditAdaptiveEngineData',
    data: params,
    muiltipart: 1,
  });
}

export function exportAdaptiveMeta(params) {
  return commonCallApi({
    path: 'adaptive/GetAdaptiveEngineDataList',
    data: params,
  });
}

export function exportCourse() {
  return commonCallApi({
    path: 'adaptive/GetIRTParameterList',
  });
}

export function collectiveReflection(params) {
  return commonCallApi({
    path: 'adaptive/ApplyIRTParameterList',
    data: params,
  });
}
